const capitalize = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);

export const ProfileMemberColumns = [
    {
        key: 'id',
        label: 'ID',
        width: '40%',
        getValue: (u: any) => <>#{u.id}</>
    },
    {
        key: 'title',
        label: 'TITLE',
        width: '80%'
    },
    {
        key: 'authorName',
        label: 'OWNED BY',
        width: '20%',
        getValue: (u: any) => (
            <div className="members-table__cell card-profile-avatar">
                <img src={u.authorAvatar} alt={u.authorName} />
                <span>{u.authorName}</span>
            </div>
        )
    },
    {
        key: 'tags',
        label: 'TAGS',
        width: '20%',
        getValue: (u: any) => u.tags.join(', ')
    },
    {
        key: 'status',
        label: 'STATUS',
        width: '20%',
        getValue: (u: any) => capitalize(u.status.toUpperCase().includes('PUBLISHED') ? 'Active': u.status)
    }
];